import { Layouts } from 'react-grid-layout';
import MappingsCell from '../../components/MenuMapping/MenuMappingCell';
import SimpleFilters from '../../components/MenuMapping/SimpleFilters';
import CopyMenuMappingAction from '../../components/MenuMapping/TableActions/CopyMenuMappingAction';
import DeleteMenuMappingAction from '../../components/MenuMapping/TableActions/DeleteMenuMappingAction';
import EditMenuMappingAction from '../../components/MenuMapping/TableActions/EditMenuMappingAction';
import { dataFormatter } from '../../components/MenuMapping/Utils';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 1,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 1,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {
        group_by: 'role_name',
        filter_options: [
            {
                fieldKey: 'app_id',
                options: [
                    { label: 'Manager', value: 'manager' },
                    { label: 'Micro Frontend', value: 'micro-fe' },
                ],
            },
        ],
    },
    components: [
        {
            name: 'menu-mapping-action-bar',
            key: 'c1',
            props: {},
        },
        {
            name: 'canopy-table',
            key: 'c2',
            apiDetails: {
                endpoint: `menu-mapping/all?`,
                endpointParams: {
                    keyword: 'keyword',
                    sort_column: 'sortColumn',
                    sort_direction: 'sortDirection',
                    role_names: 'roleName',
                    partner_names: 'partnerNames',
                    group_by: 'group_by',
                    devices: 'devices',
                },
            },
            props: {
                dataKey: 'mappings',
                showDownloadOn: ['desktop'],
                showFilterOn: ['desktop', 'tablet'],
                dataFormatter: dataFormatter,
                isClientSideFilter: true,
                isGroupedData: true,
                groupInfo: {
                    groupBy: 'role_name',
                    fieldsToAggregate: [],
                    firstKey: 'description',
                    noGroupByText: 'All Mappings',
                },
                CustomTableFilter: <SimpleFilters />,
                cellStyles: {
                    alignItems: 'flex-start',
                    py: '10px',
                },
                columns: [
                    {
                        key: 'description',
                        type: 'splitCell',
                        expandRow: true,
                        sticky: 'left',
                        colSpan: '3',
                        headerText: 'ui.mm.table-headers.name',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                        canSort: false,
                    },
                    {
                        key: 'id',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.menu-id',
                    },
                    {
                        key: 'partner_id',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.partner-id',
                    },
                    {
                        key: 'partner_code',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.partner-code',
                        canSort: true,
                    },
                    {
                        key: 'partner_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.partner-name',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'user_id',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.user-id',
                    },
                    {
                        key: 'user_display_name',
                        type: 'text',
                        headerText: 'table-headers.username',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                        canSort: true,
                    },
                    {
                        key: 'role_name',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.role-name',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'device',
                        type: 'text',
                        headerText: 'ui.mm.table-headers.device',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'app_id',
                        type: 'array',
                        headerText: 'ui.mm.table-headers.application-name',
                        selectedByDefaultOn: ['desktop', 'tablet'],
                    },
                    {
                        key: 'details',
                        type: 'json',
                        headerText: 'ui.mm.table-headers.mapping-json',
                        width: 200,
                    },
                    {
                        key: 'navbar',
                        type: 'custom',
                        cellRenderer: MappingsCell,
                        cellRendererProps: {
                            types: [
                                {
                                    name: 'menu-navbar',
                                    translationKey: 'ui.mm.page-title-',
                                    title: 'menu-navbar',
                                },
                            ],
                        },
                        headerText: 'ui.mm.table-headers.nav-bar-menus',
                        width: 200,
                    },
                    {
                        key: 'sidebar',
                        type: 'custom',
                        cellRenderer: MappingsCell,
                        cellRendererProps: {
                            types: [
                                {
                                    name: 'menu-sidebar',
                                    translationKey: 'ui.mm.side-bar-',
                                    title: 'menu-sidebar',
                                },
                            ],
                        },
                        headerText: 'ui.mm.table-headers.side-bar-menus',
                        width: 200,
                    },
                    {
                        key: 'actions',
                        type: 'actions',
                        showOnParentTable: true,
                        actions: [
                            {
                                name: 'copy_menu_mapping',
                                showOnSubTable: true,
                                showOnParentTable: false,
                                Component: <CopyMenuMappingAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                            {
                                name: 'edit_menu_mapping',
                                showOnSubTable: true,
                                showOnParentTable: false,
                                Component: <EditMenuMappingAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                            {
                                name: 'delete_menu_mapping',
                                showOnSubTable: true,
                                showOnParentTable: false,
                                Component: <DeleteMenuMappingAction />,
                                selectedByDefaultOn: [
                                    'desktop',
                                    'mobile',
                                    'tablet',
                                ],
                            },
                        ],
                        headerText: 'table-headers.actions',
                        selectedByDefaultOn: ['desktop', 'mobile', 'tablet'],
                    },
                ],

                ga_event_name: 'Menu Mapping',
            },
        },
    ],
};
